<script lang="ts" setup>
	const config = {
		paddingInline: '',
		paddingBlock: '',
		margingInline: '',
		marginBlock: 'sm:my-56 my-[100px]'
	}
	defineProps<{
		ui?: Partial<typeof config>
	}>()
	const cls = computed(() => String(useAttrs()?.class))
</script>

<template>
	<div
		:class="
			cn(
				ui?.marginBlock ?? config?.marginBlock,
				ui?.margingInline ?? config?.margingInline,
				ui?.paddingBlock ?? config.paddingBlock,
				ui?.paddingInline ?? config?.paddingInline,
				cls
			)
		"
	>
		<slot />
	</div>
</template>
